export type MonthYear = {
    month: number;
    year: number;
};

export type CalendarDayBaseProps = {
    weekIndex: number;
    weekDayIndex: number;
    dayOfMonthIndex: number;
    monthYear: MonthYear;
    isoDate: string;
};

export type TargetMonthCalendarDay = {
    type: 'target-month-calendar-day';
} & CalendarDayBaseProps;

export type PreviousMonthCalendarDay = {
    type: 'previous-month-calendar-day';
} & CalendarDayBaseProps;

export type NextMonthCalendarDay = {
    type: 'next-month-calendar-day';
} & CalendarDayBaseProps;

export type CalendarDay = TargetMonthCalendarDay | PreviousMonthCalendarDay | NextMonthCalendarDay;

export type RenderDayContentsArgs = {
    day: string;
    isTargetMonth: boolean;
    dateTime: string;
};

export type RenderCalendarContentArgs = {
    monthYear: MonthYear;
    placeholderHeight: number;
};

export type RenderCalendarContent = (args: RenderCalendarContentArgs) => React.ReactNode;

export type GetDayOnPressHandler = (calendarDay: CalendarDay) => (() => void) | undefined;
